import React from "react";
import Headline from "./Headline";
import Paragraph from "./Paragraph";
import {Colors} from "../Types";

const Footer: React.FC<Props> = ({background, headerTextColor, logo}) => {
  return(
    <div className={`w-full ${background} flex 2xl:flex-row flex-col 2xl:h-[400px] 2xl:p-0 p-6 2xl:gap-0 gap-6`}>
      <div className="2xl:w-1/3 w-full h-full flex items-center justify-center">
        <a href="./"><div className={`h-[200px] w-[200px] ${logo} bg-image`}/></a>
      </div>
      <div className="2xl:w-1/3 w-full h-full flex flex-col items-start justify-center">
        <div className="pb-6">
          <Headline color={headerTextColor} size="h3" textAlign="text-left">Contatti</Headline>
        </div>
        <Paragraph color={`text-${headerTextColor}`} size="text-base" textAlign="text-left">MR.TREWAN S.A.S. DI RUGGIERO OMAR E C.</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Via Vittorio Veneto 47 Uggiate Trevano</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Email: mrtrewan@gmail.com</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Telefono: 3497759942 (no prenotazioni telefoniche)</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">P.IVA: 04082140130</Paragraph>
      </div>
      <div className="2xl:w-1/3 w-full h-full flex flex-col items-start justify-center">
        <div className="pb-6">
          <Headline color={headerTextColor} size="h3" textAlign="text-left">Orari</Headline>
        </div>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Martedì: 9.30 / 17.30</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Mercoledì: 10.00 / 18.30</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Giovedì: 14.00 / 19.00</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Venerdì: 10.00 / 18.30</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Sabato: 8.30 / 17.30</Paragraph>
        <Paragraph color="text-white" size="text-base" textAlign="text-left">Domenica e Lunedì chiuso</Paragraph>
      </div>
    </div>
  )
};

export default Footer;

interface Props {
  background: string,
  headerTextColor:Colors;
  logo:string
}